export default {
    data: `[
   {
      "id":"b2685d94-5f23-44e5-a51e-53930b74f2e7",
      "logicalname":"sustainability_props_coal_",
      "translations":{
         "nb_NO":"Kullhaug",
         "nn_NO":"Kolhaug",
         "sv_SE":"Kålhög",
         "en_US":"Coal heap",
         "da_DK":"Kulbjerg"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":244,
      "height":150,
      "position":12,
      "updated_at":"2021-10-20T14:18:32.355+00:00"
   },
   {
      "id":"2627a401-1abc-46a6-9607-7156fff61823",
      "logicalname":"cartoonist_background_sustainability_beach_01_",
      "translations":{
         "nb_NO":"Strand 01",
         "nn_NO":"Strand 01",
         "sv_SE":"Strand 01",
         "en_US":"Beach 01",
         "da_DK":"Strand 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":0,
      "updated_at":"2021-10-20T14:17:54.273+00:00"
   },
   {
      "id":"7d37dcb2-00ce-481e-addf-d59f536d4470",
      "logicalname":"cartoonist_background_sustainability_beach_02_",
      "translations":{
         "nb_NO":"Strand 02",
         "nn_NO":"Strand 02",
         "sv_SE":"Strand 02",
         "en_US":"Beach 02",
         "da_DK":"Strand 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":1,
      "updated_at":"2021-10-20T14:17:54.591+00:00"
   },
   {
      "id":"ba993e7f-25bb-4ad1-b889-c77e1260249e",
      "logicalname":"cartoonist_background_sustainability_beach_03_",
      "translations":{
         "nb_NO":"Strand 03",
         "nn_NO":"Strand 03",
         "sv_SE":"Strand 03",
         "en_US":"Beach 03",
         "da_DK":"Strand 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":2,
      "updated_at":"2021-10-20T14:17:55.004+00:00"
   },
   {
      "id":"fc048c50-3ebf-4cbd-bd0a-42b721c7f70d",
      "logicalname":"cartoonist_background_sustainability_city_01_",
      "translations":{
         "nb_NO":"By 01",
         "nn_NO":"By 01",
         "sv_SE":"Stad 01",
         "en_US":"City 01",
         "da_DK":"By 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":3,
      "updated_at":"2021-10-20T14:17:55.401+00:00"
   },
   {
      "id":"e4cc5af5-e57f-4538-8dc5-dd5e58addc82",
      "logicalname":"cartoonist_background_sustainability_city_02_",
      "translations":{
         "nb_NO":"By 02",
         "nn_NO":"By 02",
         "sv_SE":"Stad 02",
         "en_US":"City 02",
         "da_DK":"By 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":4,
      "updated_at":"2021-10-20T14:17:55.696+00:00"
   },
   {
      "id":"9b9cf827-e824-4646-a2a2-884bedaaf88e",
      "logicalname":"cartoonist_background_sustainability_coastal_town_01_",
      "translations":{
         "nb_NO":"Kystby 01",
         "nn_NO":"Kystby 01",
         "sv_SE":"Kuststad 01",
         "en_US":"Coastal town 01",
         "da_DK":"Kystby 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":5,
      "updated_at":"2021-10-20T14:17:55.979+00:00"
   },
   {
      "id":"515e5bce-1d81-4564-91e1-168e1239a3c7",
      "logicalname":"cartoonist_background_sustainability_coastal_town_02_",
      "translations":{
         "nb_NO":"Kystby 02",
         "nn_NO":"Kystby 02",
         "sv_SE":"Kuststad 02",
         "en_US":"Coastal town 02",
         "da_DK":"Kystby 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":6,
      "updated_at":"2021-10-20T14:17:56.415+00:00"
   },
   {
      "id":"2f25502f-11b8-4b50-ab70-8d281cb110df",
      "logicalname":"cartoonist_background_sustainability_coastal_town_03_",
      "translations":{
         "nb_NO":"Kystby 03",
         "nn_NO":"Kystby 03",
         "sv_SE":"Kuststad 03",
         "en_US":"Coastal town 03",
         "da_DK":"Kystby 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":7,
      "updated_at":"2021-10-20T14:17:56.707+00:00"
   },
   {
      "id":"2f76ee92-910a-4135-b2f7-3a4632f6ad73",
      "logicalname":"cartoonist_background_sustainability_desert-spreading_01_",
      "translations":{
         "nb_NO":"Ørken 01",
         "nn_NO":"Ørken 01",
         "sv_SE":"Öken 01",
         "en_US":"Desert 01",
         "da_DK":"Ørken 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":8,
      "updated_at":"2021-10-20T14:17:56.993+00:00"
   },
   {
      "id":"20140fbd-41ae-4853-84c5-65f551288b78",
      "logicalname":"cartoonist_background_sustainability_desert-spreading_02_",
      "translations":{
         "nb_NO":"Ørken 02",
         "nn_NO":"Ørken 02",
         "sv_SE":"Öken 02",
         "en_US":"Desert 02",
         "da_DK":"Ørken 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":9,
      "updated_at":"2021-10-20T14:17:57.547+00:00"
   },
   {
      "id":"dad6609c-8b5d-421b-8d33-763902c4bb92",
      "logicalname":"cartoonist_background_sustainability_desert-spreading_03_",
      "translations":{
         "nb_NO":"Ørken 03",
         "nn_NO":"Ørken 03",
         "sv_SE":"Öken 03",
         "en_US":"Desert 03",
         "da_DK":"Ørken 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":10,
      "updated_at":"2021-10-20T14:17:57.844+00:00"
   },
   {
      "id":"e6b03709-0c69-4391-8f80-aea70d8da028",
      "logicalname":"cartoonist_background_sustainability_forest_01_",
      "translations":{
         "nb_NO":"Skog 01",
         "nn_NO":"Skog 01",
         "sv_SE":"Skog 01",
         "en_US":"Forest 01",
         "da_DK":"Skov 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":11,
      "updated_at":"2021-10-20T14:17:58.225+00:00"
   },
   {
      "id":"02dcbd7f-be02-4288-95ca-18570c7838f4",
      "logicalname":"cartoonist_background_sustainability_forest_02_",
      "translations":{
         "nb_NO":"Skog 02",
         "nn_NO":"Skog 02",
         "sv_SE":"Skog 02",
         "en_US":"Forest 02",
         "da_DK":"Skov 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":12,
      "updated_at":"2021-10-20T14:17:58.603+00:00"
   },
   {
      "id":"50c08860-170a-46da-b771-b3722cf93877",
      "logicalname":"cartoonist_background_sustainability_forest_03_",
      "translations":{
         "nb_NO":"Skog 03",
         "nn_NO":"Skog 03",
         "sv_SE":"Skog 03",
         "en_US":"Forest 03",
         "da_DK":"Skov 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":13,
      "updated_at":"2021-10-20T14:17:58.887+00:00"
   },
   {
      "id":"06f977b9-6c35-41d5-8a3e-b9c155cf175a",
      "logicalname":"cartoonist_background_sustainability_oilplatform_01_",
      "translations":{
         "nb_NO":"Oljerigg",
         "nn_NO":"Oljerigg",
         "sv_SE":"Oljerigg",
         "en_US":"Oil rig",
         "da_DK":"Boreplatform"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":14,
      "updated_at":"2021-10-20T14:17:59.194+00:00"
   },
   {
      "id":"6dc35b89-1d60-42b6-918c-cfe344b30c27",
      "logicalname":"cartoonist_background_sustainability_rainforest_01_",
      "translations":{
         "nb_NO":"Regnskog 01",
         "nn_NO":"Regnskog 01",
         "sv_SE":"Regnskog 01",
         "en_US":"Rainforest 01",
         "da_DK":"Regnskov 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":15,
      "updated_at":"2021-10-20T14:17:59.508+00:00"
   },
   {
      "id":"71c3b8a2-9342-4247-a6b2-c098ece36157",
      "logicalname":"cartoonist_background_sustainability_rainforest_02_",
      "translations":{
         "nb_NO":"Regnskog 02",
         "nn_NO":"Regnskog 02",
         "sv_SE":"Regnskog 02",
         "en_US":"Rainforest 02",
         "da_DK":"Regnskov 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":16,
      "updated_at":"2021-10-20T14:17:59.794+00:00"
   },
   {
      "id":"fe52db6c-7f24-45be-8604-073286fdfe94",
      "logicalname":"cartoonist_background_sustainability_rainforest_03_",
      "translations":{
         "nb_NO":"Regnskog 03",
         "nn_NO":"Regnskog 03",
         "sv_SE":"Regnskog 03",
         "en_US":"Rainforest 03",
         "da_DK":"Regnskov 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":17,
      "updated_at":"2021-10-20T14:18:00.215+00:00"
   },
   {
      "id":"dc900d2d-f8ca-41be-b3b3-b209e13a588b",
      "logicalname":"cartoonist_background_sustainability_slum_01_",
      "translations":{
         "nb_NO":"Slum",
         "nn_NO":"Slum",
         "sv_SE":"Slum ",
         "en_US":"Slum ",
         "da_DK":"Slumkvarter "
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":18,
      "updated_at":"2021-10-20T14:18:00.501+00:00"
   },
   {
      "id":"ebe2b007-cfd0-43f6-831b-d6202e5d8673",
      "logicalname":"cartoonist_background_sustainability_vindmills_01_",
      "translations":{
         "nb_NO":"Vindmølle",
         "nn_NO":"Vindmølle",
         "sv_SE":"Vindkraftverk",
         "en_US":"Windmill",
         "da_DK":"Vindmølle"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":19,
      "updated_at":"2021-10-20T14:18:00.805+00:00"
   },
   {
      "id":"81494cd9-cf18-4c2b-9431-baf6ab3a9767",
      "logicalname":"cartoonist_background_sustainability_waterfall_01_",
      "translations":{
         "nb_NO":"Foss 01",
         "nn_NO":"Foss 01",
         "sv_SE":"Vattenfall 01",
         "en_US":"Waterfall 01",
         "da_DK":"Vandfald 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":20,
      "updated_at":"2021-10-20T14:18:01.114+00:00"
   },
   {
      "id":"2d94ee1d-3299-494b-bd7f-244b4119f36d",
      "logicalname":"cartoonist_background_sustainability_waterfall_02_",
      "translations":{
         "nb_NO":"Foss 02",
         "nn_NO":"Foss 02",
         "sv_SE":"Vattenfall 02",
         "en_US":"Waterfall 02",
         "da_DK":"Vandfald 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":21,
      "updated_at":"2021-10-20T14:18:01.431+00:00"
   },
   {
      "id":"467fcd7b-38f1-4ee9-89b3-b3a386fde12b",
      "logicalname":"cartoonist_background_sustainability_waterfall_03_",
      "translations":{
         "nb_NO":"Foss 03",
         "nn_NO":"Foss 03",
         "sv_SE":"Vattenfall 03",
         "en_US":"Waterfall 03",
         "da_DK":"Vandfald 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         "day",
         "night"
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":22,
      "updated_at":"2021-10-20T14:18:02.025+00:00"
   },
   {
      "id":"756ea4ec-31c8-464a-ba72-4e1ccb718a87",
      "logicalname":"cartoonist_background_sustainability_antarctica_01_",
      "translations":{
         "nb_NO":"Antarktis 01",
         "nn_NO":"Antarktis 01",
         "sv_SE":"Antarktis 01",
         "en_US":"Antarctica 01",
         "da_DK":"Antarktis 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":23,
      "updated_at":"2021-10-20T14:18:02.343+00:00"
   },
   {
      "id":"ea9e0d10-bd77-40e3-9fa1-85c8401d05f0",
      "logicalname":"cartoonist_background_sustainability_antarctica_02_",
      "translations":{
         "nb_NO":"Antarktis 02",
         "nn_NO":"Antarktis 02",
         "sv_SE":"Antarktis 02",
         "en_US":"Antarctica 02",
         "da_DK":"Antarktis 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":24,
      "updated_at":"2021-10-20T14:18:02.736+00:00"
   },
   {
      "id":"4567e0da-d6f5-48dd-8d76-3d2af977dbe3",
      "logicalname":"cartoonist_background_sustainability_antarctica_03_",
      "translations":{
         "nb_NO":"Antarktis 03",
         "nn_NO":"Antarktis 03",
         "sv_SE":"Antarktis 03",
         "en_US":"Antarctica 03",
         "da_DK":"Antarktis 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":25,
      "updated_at":"2021-10-20T14:18:03.027+00:00"
   },
   {
      "id":"df3e3c97-27cd-4801-9aa8-920d93ac4a85",
      "logicalname":"cartoonist_background_sustainability_arctic_01_",
      "translations":{
         "nb_NO":"Arktis 01",
         "nn_NO":"Arktis 01",
         "sv_SE":"Arktis 01",
         "en_US":"Arctic 01",
         "da_DK":"Arktis 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":26,
      "updated_at":"2021-10-20T14:18:03.319+00:00"
   },
   {
      "id":"92153875-a49a-440b-8347-4c0f7539fa0b",
      "logicalname":"cartoonist_background_sustainability_arctic_02_",
      "translations":{
         "nb_NO":"Arktis 02",
         "nn_NO":"Arktis 02",
         "sv_SE":"Arktis 02",
         "en_US":"Arctic 02",
         "da_DK":"Arktis 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":27,
      "updated_at":"2021-10-20T14:18:03.613+00:00"
   },
   {
      "id":"413e86da-32f9-4a79-83d2-596f8201c08a",
      "logicalname":"cartoonist_background_sustainability_arctic_03_",
      "translations":{
         "nb_NO":"Arktis 03",
         "nn_NO":"Arktis 03",
         "sv_SE":"Arktis 03",
         "en_US":"Arctic 03",
         "da_DK":"Arktis 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":28,
      "updated_at":"2021-10-20T14:18:03.917+00:00"
   },
   {
      "id":"686a15fb-aa76-450a-946b-60bc3a862b76",
      "logicalname":"cartoonist_background_sustainability_underwater_01_",
      "translations":{
         "nb_NO":"Under vann 01",
         "nn_NO":"Under vatn 01",
         "sv_SE":"Undervatten 01",
         "en_US":"Underwater 01",
         "da_DK":"Under vandet 01"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":29,
      "updated_at":"2021-10-20T14:18:04.314+00:00"
   },
   {
      "id":"72b5ae00-c5a7-43ed-8dad-baff39025478",
      "logicalname":"cartoonist_background_sustainability_underwater_02_",
      "translations":{
         "nb_NO":"Under vann 02",
         "nn_NO":"Under vatn 02",
         "sv_SE":"Undervatten 02",
         "en_US":"Underwater 02",
         "da_DK":"Under vandet 02"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":30,
      "updated_at":"2021-10-20T14:18:04.679+00:00"
   },
   {
      "id":"20c378ce-edf4-43f9-a71e-8f1bd54e4e3d",
      "logicalname":"cartoonist_background_sustainability_underwater_03_",
      "translations":{
         "nb_NO":"Under vann 03",
         "nn_NO":"Under vatn 03",
         "sv_SE":"Undervatten 03",
         "en_US":"Underwater 03",
         "da_DK":"Under vandet 03"
      },
      "theme":"sustainable_development",
      "type":"backgrounds",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":800,
      "height":450,
      "position":31,
      "updated_at":"2021-10-20T14:18:04.969+00:00"
   },
   {
      "id":"b875cd83-583e-49dd-ab22-00059eddf509",
      "logicalname":"sustainability_boy_01_running_",
      "translations":{
         "nb_NO":"Gutt 01 løper",
         "nn_NO":"Gut 01 spring",
         "sv_SE":"Pojke 01 springer",
         "en_US":"Boy 01 running",
         "da_DK":"Dreng 01 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":245,
      "height":322,
      "position":0,
      "updated_at":"2021-10-20T14:18:05.470+00:00"
   },
   {
      "id":"5a4d7484-4eb0-4053-bf3e-3de05cfbea4e",
      "logicalname":"sustainability_boy_01_sitting_",
      "translations":{
         "nb_NO":"Gutt 01 sitter",
         "nn_NO":"Gut 01 sit",
         "sv_SE":"Pojke 01 sitter",
         "en_US":"Boy 01 sitting",
         "da_DK":"Dreng 01 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":167,
      "height":303,
      "position":1,
      "updated_at":"2021-10-20T14:18:05.762+00:00"
   },
   {
      "id":"71f56a2f-20bd-4387-8e9b-f3b3a86dce51",
      "logicalname":"sustainability_boy_01_standing_",
      "translations":{
         "nb_NO":"Gutt 01 står",
         "nn_NO":"Gut 01 står",
         "sv_SE":"Pojke 01 står",
         "en_US":"Boy 01 standing",
         "da_DK":"Dreng 01 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":123,
      "height":341,
      "position":2,
      "updated_at":"2021-10-20T14:18:06.111+00:00"
   },
   {
      "id":"f211f149-cc4b-43b1-8bb3-a01dab89d72f",
      "logicalname":"sustainability_boy_01_walking_",
      "translations":{
         "nb_NO":"Gutt 01 går",
         "nn_NO":"Gut 01 går",
         "sv_SE":"Pojke 01 går",
         "en_US":"Boy 01 walking",
         "da_DK":"Dreng 01 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":144,
      "height":333,
      "position":3,
      "updated_at":"2021-10-20T14:18:06.404+00:00"
   },
   {
      "id":"827d3a2e-81b9-4b77-8dfb-bed54524261c",
      "logicalname":"sustainability_boy_02_running_",
      "translations":{
         "nb_NO":"Gutt 02 løper",
         "nn_NO":"Gut 02 spring",
         "sv_SE":"Pojke 02 springer",
         "en_US":"Boy 02 running",
         "da_DK":"Dreng 02 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":229,
      "height":353,
      "position":58,
      "updated_at":"2021-10-20T14:18:06.703+00:00"
   },
   {
      "id":"5b3614ac-1512-4b97-aba3-645fde31490a",
      "logicalname":"sustainability_boy_02_sitting_",
      "translations":{
         "nb_NO":"Gutt 02 sitter",
         "nn_NO":"Gut 02 sit",
         "sv_SE":"Pojke 02 sitter",
         "en_US":"Boy 02 sitting",
         "da_DK":"Dreng 02 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":158,
      "height":331,
      "position":57,
      "updated_at":"2021-10-20T14:18:07.111+00:00"
   },
   {
      "id":"4f38b271-5e99-439c-b6af-e0471fdb2d8c",
      "logicalname":"sustainability_boy_02_standing_",
      "translations":{
         "nb_NO":"Gutt 02 står",
         "nn_NO":"Gut 02 står",
         "sv_SE":"Pojke 02 står",
         "en_US":"Boy 02 standing",
         "da_DK":"Dreng 02 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":122,
      "height":363,
      "position":56,
      "updated_at":"2021-10-20T14:18:07.398+00:00"
   },
   {
      "id":"70975553-65c3-4751-95a5-fcb9d4d27d6f",
      "logicalname":"sustainability_boy_02_walking_",
      "translations":{
         "nb_NO":"Gutt 02 går",
         "nn_NO":"Gut 02 går",
         "sv_SE":"Pojke 02 går",
         "en_US":"Boy 02 walking",
         "da_DK":"Dreng 02 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":143,
      "height":354,
      "position":55,
      "updated_at":"2021-10-20T14:18:07.688+00:00"
   },
   {
      "id":"69564493-fb52-46f6-b8cc-505f20a760ce",
      "logicalname":"sustainability_girl_01_running_",
      "translations":{
         "nb_NO":"Jente 01 løper",
         "nn_NO":"Jente 01 spring",
         "sv_SE":"Greta springer",
         "en_US":"Girl 01 running",
         "da_DK":"Pige 01 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":249,
      "height":341,
      "position":4,
      "updated_at":"2021-10-20T14:18:08.088+00:00"
   },
   {
      "id":"f71f82f4-9edb-49d0-a5e4-30847dc721c0",
      "logicalname":"sustainability_girl_01_sitting_",
      "translations":{
         "nb_NO":"Jente 01 sitter",
         "nn_NO":"Jente 01 sit",
         "sv_SE":"Greta sitter",
         "en_US":"Girl 01 sitting",
         "da_DK":"Pige 01 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":169,
      "height":205,
      "position":5,
      "updated_at":"2021-10-20T14:18:08.416+00:00"
   },
   {
      "id":"f5d21337-7055-4ae4-8914-cf9fde4e2dcb",
      "logicalname":"sustainability_girl_01_standing_",
      "translations":{
         "nb_NO":"Jente 01 står",
         "nn_NO":"Jente 01 står",
         "sv_SE":"Greta står",
         "en_US":"Girl 01 standing",
         "da_DK":"Pige 01 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":134,
      "height":344,
      "position":6,
      "updated_at":"2021-10-20T14:18:08.726+00:00"
   },
   {
      "id":"83459bc4-68f0-437b-b4d2-38b987d17816",
      "logicalname":"sustainability_girl_01_walking_",
      "translations":{
         "nb_NO":"Jente 01 går",
         "nn_NO":"Jente 01 går",
         "sv_SE":"Greta går",
         "en_US":"Girl 01 walking",
         "da_DK":"Pige 01 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":144,
      "height":333,
      "position":7,
      "updated_at":"2021-10-20T14:18:09.106+00:00"
   },
   {
      "id":"8cb84ead-cad5-44d2-ba3b-b6596ca4289f",
      "logicalname":"sustainability_girl_02_running_",
      "translations":{
         "nb_NO":"Jente 02 løper",
         "nn_NO":"Jente 02 spring",
         "sv_SE":"Flicka 02 springer",
         "en_US":"Girl 02 running",
         "da_DK":"Pige 02 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":242,
      "height":342,
      "position":54,
      "updated_at":"2021-10-20T14:18:09.431+00:00"
   },
   {
      "id":"dea15555-4c4a-453a-b423-b90a3641654b",
      "logicalname":"sustainability_girl_02_sitting_",
      "translations":{
         "nb_NO":"Jente 02 sitter",
         "nn_NO":"Jente 02 sit",
         "sv_SE":"Flicka 02 sitter",
         "en_US":"Girl 02 sitting",
         "da_DK":"Pige 02 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":162,
      "height":291,
      "position":53,
      "updated_at":"2021-10-20T14:18:09.782+00:00"
   },
   {
      "id":"978e3e95-e34a-4e51-be3a-7e68add755ef",
      "logicalname":"sustainability_girl_02_standing_",
      "translations":{
         "nb_NO":"Jente 02 står",
         "nn_NO":"Jente 02 står",
         "sv_SE":"Flicka 02 står",
         "en_US":"Girl 02 standing",
         "da_DK":"Pige 02 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":110,
      "height":351,
      "position":52,
      "updated_at":"2021-10-20T14:18:10.072+00:00"
   },
   {
      "id":"ff1e92ae-3b9e-4377-aada-a57bb266cd4e",
      "logicalname":"sustainability_girl_02_walking_",
      "translations":{
         "nb_NO":"Jente 02 går",
         "nn_NO":"Jente 02 går",
         "sv_SE":"Flicka 02 går",
         "en_US":"Girl 02 walking",
         "da_DK":"Pige 02 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":131,
      "height":341,
      "position":51,
      "updated_at":"2021-10-20T14:18:10.379+00:00"
   },
   {
      "id":"dc0c4d16-2172-4c4f-a0f8-48d9294cd1cc",
      "logicalname":"sustainability_girl_03_running_",
      "translations":{
         "nb_NO":"Jente 03 løper",
         "nn_NO":"Jente 03 spring",
         "sv_SE":"Flicka 03 springer",
         "en_US":"Girl 03 running",
         "da_DK":"Pige 03 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":173,
      "height":315,
      "position":50,
      "updated_at":"2021-10-20T14:18:10.805+00:00"
   },
   {
      "id":"9463fe5b-fc1e-4eed-ae66-e75a81c39197",
      "logicalname":"sustainability_girl_03_sitting_",
      "translations":{
         "nb_NO":"Jente 03 sitter",
         "nn_NO":"Jente 03 sit",
         "sv_SE":"Flicka 03 sitter",
         "en_US":"Girl 03 sitting",
         "da_DK":"Pige 03 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":175,
      "height":297,
      "position":49,
      "updated_at":"2021-10-20T14:18:11.150+00:00"
   },
   {
      "id":"69663b3c-c102-4376-9f1a-b2fcadc8390f",
      "logicalname":"sustainability_girl_03_standing_",
      "translations":{
         "nb_NO":"Jente 03 står",
         "nn_NO":"Jente 03 står",
         "sv_SE":"Flicka 03 står",
         "en_US":"Girl 03 standing",
         "da_DK":"Pige 03 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":135,
      "height":334,
      "position":48,
      "updated_at":"2021-10-20T14:18:11.542+00:00"
   },
   {
      "id":"c5116613-7140-476e-8353-7ce610bd387a",
      "logicalname":"sustainability_girl_03_walking_",
      "translations":{
         "nb_NO":"Jente 03 går",
         "nn_NO":"Jente 03 går",
         "sv_SE":"Flicka 03 går",
         "en_US":"Girl 03 walking",
         "da_DK":"Pige 03 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":135,
      "height":309,
      "position":47,
      "updated_at":"2021-10-20T14:18:11.839+00:00"
   },
   {
      "id":"dde094ae-3562-4bea-ace3-5c7d05b5c61b",
      "logicalname":"sustainability_girl_04_running_",
      "translations":{
         "nb_NO":"Jente 04 løper",
         "nn_NO":"Jente 04 spring",
         "sv_SE":"Flicka 04 springer",
         "en_US":"Girl 04 running",
         "da_DK":"Pige 04 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":201,
      "height":333,
      "position":46,
      "updated_at":"2021-10-20T14:18:12.136+00:00"
   },
   {
      "id":"2c41f22e-9969-4497-beee-9065e2dc328d",
      "logicalname":"sustainability_girl_04_sitting_",
      "translations":{
         "nb_NO":"Jente 04 sitter",
         "nn_NO":"Jente 04 sit",
         "sv_SE":"Flicka 04 sitter",
         "en_US":"Girl 04 sitting",
         "da_DK":"Pige 04 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":153,
      "height":314,
      "position":45,
      "updated_at":"2021-10-20T14:18:12.431+00:00"
   },
   {
      "id":"2d0d32dd-2f32-45cd-b770-573cd7cf6e6b",
      "logicalname":"sustainability_girl_04_standing_",
      "translations":{
         "nb_NO":"Jente 04 står",
         "nn_NO":"Jente 04 står",
         "sv_SE":"Flicka 04 står",
         "en_US":"Girl 04 standing",
         "da_DK":"Pige 04 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":109,
      "height":349,
      "position":44,
      "updated_at":"2021-10-20T14:18:12.863+00:00"
   },
   {
      "id":"d98638d1-1126-4b8f-ab3f-38baf977b01b",
      "logicalname":"sustainability_girl_04_walking_",
      "translations":{
         "nb_NO":"Jente 04 går",
         "nn_NO":"Jente 04 går",
         "sv_SE":"Flicka 04 går",
         "en_US":"Girl 04 walking",
         "da_DK":"Pige 04 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":128,
      "height":346,
      "position":43,
      "updated_at":"2021-10-20T14:18:13.153+00:00"
   },
   {
      "id":"0a4afb7b-9199-42c0-800f-aa306a19e1d3",
      "logicalname":"sustainability_man_01_running_",
      "translations":{
         "nb_NO":"Mann 01 løper",
         "nn_NO":"Mann 01 spring",
         "sv_SE":"Man 01 springer",
         "en_US":"Man 01 running",
         "da_DK":"Mand 01 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":260,
      "height":449,
      "position":8,
      "updated_at":"2021-10-20T14:18:13.454+00:00"
   },
   {
      "id":"b6b4f1c9-984b-4547-aee0-aacae8a15573",
      "logicalname":"sustainability_man_01_sitting_",
      "translations":{
         "nb_NO":"Mann 01 sitter",
         "nn_NO":"Mann 01 sit",
         "sv_SE":"Man 01 sitter",
         "en_US":"Man 01 sitting",
         "da_DK":"Mand 01 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":299,
      "height":353,
      "position":9,
      "updated_at":"2021-10-20T14:18:13.857+00:00"
   },
   {
      "id":"ea16ce50-0c93-4612-bb7e-99ba03a2cb79",
      "logicalname":"sustainability_man_01_standing_",
      "translations":{
         "nb_NO":"Mann 01 står",
         "nn_NO":"Mann 01 står",
         "sv_SE":"Man 01 står",
         "en_US":"Man 01 standing",
         "da_DK":"Mand 01 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":140,
      "height":461,
      "position":10,
      "updated_at":"2021-10-20T14:18:14.150+00:00"
   },
   {
      "id":"f7468567-e508-4a89-8dc2-d3ab17d56107",
      "logicalname":"sustainability_man_01_walking_",
      "translations":{
         "nb_NO":"Mann 01 går",
         "nn_NO":"Mann 01 går",
         "sv_SE":"Man 01 går",
         "en_US":"Man 01 walking",
         "da_DK":"Mand 01 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":156,
      "height":443,
      "position":11,
      "updated_at":"2021-10-20T14:18:14.526+00:00"
   },
   {
      "id":"8a3f98fd-17fc-4abc-8355-021e92e09748",
      "logicalname":"sustainability_man_02_running_",
      "translations":{
         "nb_NO":"Mann 02 løper",
         "nn_NO":"Mann 02 spring",
         "sv_SE":"Man 02 springer",
         "en_US":"Man 02 running",
         "da_DK":"Mand 02 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":233,
      "height":382,
      "position":12,
      "updated_at":"2021-10-20T14:18:14.826+00:00"
   },
   {
      "id":"a7c52316-bc22-4db0-abf3-a224daac378d",
      "logicalname":"sustainability_man_02_sitting_",
      "translations":{
         "nb_NO":"Mann 02 sitter",
         "nn_NO":"Mann 02 sit",
         "sv_SE":"Man 02 sitter",
         "en_US":"Man 02 sitting",
         "da_DK":"Mand 02 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":214,
      "height":358,
      "position":13,
      "updated_at":"2021-10-20T14:18:15.215+00:00"
   },
   {
      "id":"324193aa-cac8-4e3e-9969-0148ea5be8ef",
      "logicalname":"sustainability_man_02_standing_",
      "translations":{
         "nb_NO":"Mann 02 står",
         "nn_NO":"Mann 02 står",
         "sv_SE":"Man 02 står",
         "en_US":"Man 02 standing",
         "da_DK":"Mand 02 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":137,
      "height":409,
      "position":14,
      "updated_at":"2021-10-20T14:18:15.510+00:00"
   },
   {
      "id":"859a4124-e44b-485e-82dd-0fcd433ab9c3",
      "logicalname":"sustainability_man_02_walking_",
      "translations":{
         "nb_NO":"Mann 02 går",
         "nn_NO":"Mann 02 går",
         "sv_SE":"Man 02 går",
         "en_US":"Man 02 walking",
         "da_DK":"Mand 02 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":171,
      "height":398,
      "position":15,
      "updated_at":"2021-10-20T14:18:15.813+00:00"
   },
   {
      "id":"55a2c9df-00c0-4c52-a02f-3678821af9a2",
      "logicalname":"sustainability_man_03_running_",
      "translations":{
         "nb_NO":"Mann 03 løper",
         "nn_NO":"Mann 03 spring",
         "sv_SE":"Man 03 springer",
         "en_US":"Man 03 running",
         "da_DK":"Mand 03 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":264,
      "height":419,
      "position":16,
      "updated_at":"2021-10-20T14:18:16.256+00:00"
   },
   {
      "id":"c43963cf-4006-4b83-8360-df9c1ffde5f3",
      "logicalname":"sustainability_man_03_sitting_",
      "translations":{
         "nb_NO":"Mann 03 sitter",
         "nn_NO":"Mann 03 sit",
         "sv_SE":"Man 03 sitter",
         "en_US":"Man 03 sitting",
         "da_DK":"Mand 03 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":218,
      "height":385,
      "position":17,
      "updated_at":"2021-10-20T14:18:16.540+00:00"
   },
   {
      "id":"8100202b-3ee1-4413-9e39-14b7fa6a0a57",
      "logicalname":"sustainability_man_03_standing_",
      "translations":{
         "nb_NO":"Mann 03 står",
         "nn_NO":"Mann 03 står",
         "sv_SE":"Man 03 står",
         "en_US":"Man 03 standing",
         "da_DK":"Mand 03 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":138,
      "height":438,
      "position":18,
      "updated_at":"2021-10-20T14:18:16.831+00:00"
   },
   {
      "id":"277ba8df-1bc4-453b-a91b-6a8077919733",
      "logicalname":"sustainability_man_03_walking_",
      "translations":{
         "nb_NO":"Mann 03 går",
         "nn_NO":"Mann 03 går",
         "sv_SE":"Man 03 går",
         "en_US":"Man 03 walking",
         "da_DK":"Mand 03 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":141,
      "height":436,
      "position":19,
      "updated_at":"2021-10-20T14:18:17.141+00:00"
   },
   {
      "id":"7dc08f1c-3f8e-426f-88f8-9342bd8b05de",
      "logicalname":"sustainability_man_04_running_",
      "translations":{
         "nb_NO":"Mann 04 løper",
         "nn_NO":"Mann 04 spring",
         "sv_SE":"Man 04 springer",
         "en_US":"Man 04 running",
         "da_DK":"Mand 04 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":234,
      "height":357,
      "position":20,
      "updated_at":"2021-10-20T14:18:17.584+00:00"
   },
   {
      "id":"c63dedc1-d0d4-4f4b-a7c0-fb0fbc6704a3",
      "logicalname":"sustainability_man_04_sitting_",
      "translations":{
         "nb_NO":"Mann 04 sitter",
         "nn_NO":"Mann 04 sit",
         "sv_SE":"Man 04 sitter",
         "en_US":"Man 04 sitting",
         "da_DK":"Mand 04 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":203,
      "height":330,
      "position":21,
      "updated_at":"2021-10-20T14:18:17.873+00:00"
   },
   {
      "id":"604225f4-5661-49ee-a2b4-e59817ad19b4",
      "logicalname":"sustainability_man_04_standing_",
      "translations":{
         "nb_NO":"Mann 04 står",
         "nn_NO":"Mann 04 står",
         "sv_SE":"Man 04 står",
         "en_US":"Man 04 standing",
         "da_DK":"Mand 04 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":137,
      "height":408,
      "position":22,
      "updated_at":"2021-10-20T14:18:18.185+00:00"
   },
   {
      "id":"3216a462-ae2f-4748-ad05-fab07df3f2b8",
      "logicalname":"sustainability_man_04_walking_",
      "translations":{
         "nb_NO":"Mann 04 går",
         "nn_NO":"Mann 04 går",
         "sv_SE":"Man 04 går",
         "en_US":"Man 04 walking",
         "da_DK":"Mand 04 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":162,
      "height":401,
      "position":23,
      "updated_at":"2021-10-20T14:18:18.498+00:00"
   },
   {
      "id":"229858fa-71b7-488d-8aa4-cca357b56d6d",
      "logicalname":"sustainability_man_05_running_",
      "translations":{
         "nb_NO":"Mann 05 løper",
         "nn_NO":"Mann 05 spring",
         "sv_SE":"Man 05 springer",
         "en_US":"Man 05 running",
         "da_DK":"Mand 05 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":232,
      "height":392,
      "position":42,
      "updated_at":"2021-10-20T14:18:18.819+00:00"
   },
   {
      "id":"9000bfb9-8ed4-4d1e-b96e-f2c7d2410e2f",
      "logicalname":"sustainability_man_05_sitting_",
      "translations":{
         "nb_NO":"Mann 05 sitter",
         "nn_NO":"Mann 05 sit",
         "sv_SE":"Man 05 sitter",
         "en_US":"Man 05 sitting",
         "da_DK":"Mand 05 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":173,
      "height":324,
      "position":41,
      "updated_at":"2021-10-20T14:18:19.115+00:00"
   },
   {
      "id":"a8de1f1e-011e-4ef5-b7ac-47a589422f0f",
      "logicalname":"sustainability_man_05_standing_",
      "translations":{
         "nb_NO":"Mann 05 står",
         "nn_NO":"Mann 05 står",
         "sv_SE":"Man 05 står",
         "en_US":"Man 05 standing",
         "da_DK":"Mand 05 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":203,
      "height":400,
      "position":40,
      "updated_at":"2021-10-20T14:18:19.426+00:00"
   },
   {
      "id":"f57d165b-3327-4173-9ffd-bd94b4a9e006",
      "logicalname":"sustainability_man_05_walking_",
      "translations":{
         "nb_NO":"Mann 05 går",
         "nn_NO":"Mann 05 går",
         "sv_SE":"Man 05 går",
         "en_US":"Man 05 walking",
         "da_DK":"Mand 05 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":168,
      "height":401,
      "position":39,
      "updated_at":"2021-10-20T14:18:19.906+00:00"
   },
   {
      "id":"32aa2100-a01c-4604-912b-1be9bf36548a",
      "logicalname":"sustainability_woman_01_running_",
      "translations":{
         "nb_NO":"Kvinne 01 løper",
         "nn_NO":"Kvinne 01 spring",
         "sv_SE":"Kvinna 01 springer",
         "en_US":"Woman 01 running",
         "da_DK":"Kvinde 01 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":235,
      "height":377,
      "position":24,
      "updated_at":"2021-10-20T14:18:20.202+00:00"
   },
   {
      "id":"7b3bcea4-1e8b-42a3-a58b-0350ff0addce",
      "logicalname":"sustainability_woman_01_sitting_",
      "translations":{
         "nb_NO":"Kvinne 01 sitter",
         "nn_NO":"Kvinne 01 sit",
         "sv_SE":"Kvinna 01 sitter",
         "en_US":"Woman 01 sitting",
         "da_DK":"Kvinde 01 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":184,
      "height":334,
      "position":25,
      "updated_at":"2021-10-20T14:18:20.499+00:00"
   },
   {
      "id":"e1e37442-a8e8-45cb-bf09-7d0bef647d4d",
      "logicalname":"sustainability_woman_01_standing_",
      "translations":{
         "nb_NO":"Kvinne 01 står",
         "nn_NO":"Kvinne 01 står",
         "sv_SE":"Kvinna 01 står",
         "en_US":"Woman 01 standing",
         "da_DK":"Kvinde 01 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":136,
      "height":403,
      "position":26,
      "updated_at":"2021-10-20T14:18:20.798+00:00"
   },
   {
      "id":"f9b0c45d-9a9d-4373-a5a3-a3f5dc73febb",
      "logicalname":"sustainability_woman_01_walking_",
      "translations":{
         "nb_NO":"Kvinne 01 går",
         "nn_NO":"Kvinne 01 går",
         "sv_SE":"Kvinna 01 går",
         "en_US":"Woman 01 walking",
         "da_DK":"Kvinde 01 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":177,
      "height":397,
      "position":27,
      "updated_at":"2021-10-20T14:18:21.096+00:00"
   },
   {
      "id":"0ecc281a-2627-4a5f-9fd4-8f417eb1f124",
      "logicalname":"sustainability_woman_02_running_",
      "translations":{
         "nb_NO":"Kvinne 02 løper",
         "nn_NO":"Kvinne 02 spring",
         "sv_SE":"Kvinna 02 springer",
         "en_US":"Woman 02 running",
         "da_DK":"Kvinde 02 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":219,
      "height":383,
      "position":38,
      "updated_at":"2021-10-20T14:18:21.389+00:00"
   },
   {
      "id":"96586d4a-0904-492c-a419-6faf342d42ae",
      "logicalname":"sustainability_woman_02_sitting_",
      "translations":{
         "nb_NO":"Kvinne 02 sitter",
         "nn_NO":"Kvinne 02 sit",
         "sv_SE":"Kvinna 02 sitter",
         "en_US":"Woman 02 sitting",
         "da_DK":"Kvinde 02 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":207,
      "height":345,
      "position":37,
      "updated_at":"2021-10-20T14:18:21.763+00:00"
   },
   {
      "id":"b45aa3d0-a778-495a-88b3-1b4e42276529",
      "logicalname":"sustainability_woman_02_standing_",
      "translations":{
         "nb_NO":"Kvinne 02 står",
         "nn_NO":"Kvinne 02 står",
         "sv_SE":"Kvinna 02 står",
         "en_US":"Woman 02 standing",
         "da_DK":"Kvinde 02 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":135,
      "height":400,
      "position":36,
      "updated_at":"2021-10-20T14:18:22.058+00:00"
   },
   {
      "id":"e6692e49-de19-491c-bf45-3c9a57c63377",
      "logicalname":"sustainability_woman_02_walking_",
      "translations":{
         "nb_NO":"Kvinne 02 går",
         "nn_NO":"Kvinne 02 går",
         "sv_SE":"Kvinna 02 går",
         "en_US":"Woman 02 walking",
         "da_DK":"Kvinde 02 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":159,
      "height":387,
      "position":35,
      "updated_at":"2021-10-20T14:18:22.577+00:00"
   },
   {
      "id":"1725cb99-5e76-4570-adb5-734a5f5dd7be",
      "logicalname":"sustainability_child_01_running_",
      "translations":{
         "nb_NO":"Barn 01 løper",
         "nn_NO":"Barn 01 spring",
         "sv_SE":"Barn 01 springer",
         "en_US":"Child 01 running",
         "da_DK":"Barn 01 løber"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":175,
      "height":278,
      "position":34,
      "updated_at":"2021-10-20T14:18:22.871+00:00"
   },
   {
      "id":"367cd88d-d577-42f8-9ca8-f636e91c0c41",
      "logicalname":"sustainability_child_01_sitting_",
      "translations":{
         "nb_NO":"Barn 01 sitter",
         "nn_NO":"Barn 01 sit",
         "sv_SE":"Barn 01 sitter",
         "en_US":"Child 01 sitting",
         "da_DK":"Barn 01 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":137,
      "height":263,
      "position":33,
      "updated_at":"2021-10-20T14:18:23.238+00:00"
   },
   {
      "id":"4f00ea75-e43c-40c1-b85b-25308f869517",
      "logicalname":"sustainability_child_01_standing_",
      "translations":{
         "nb_NO":"Barn 01 står",
         "nn_NO":"Barn 01 står",
         "sv_SE":"Barn 01 Står",
         "en_US":"Child 01 standing",
         "da_DK":"Barn 01 står"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":96,
      "height":286,
      "position":32,
      "updated_at":"2021-10-20T14:18:23.612+00:00"
   },
   {
      "id":"85ff7d81-5dd4-4208-9ae0-78eb5f413e0d",
      "logicalname":"sustainability_child_01_walking_",
      "translations":{
         "nb_NO":"Barn 01 går",
         "nn_NO":"Born 01 går",
         "sv_SE":"Barn 01 Går",
         "en_US":"Child 01 walking",
         "da_DK":"Barn 01 går"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "sad",
         "angry",
         "behind"
      ],
      "tags":[
         
      ],
      "width":114,
      "height":276,
      "position":31,
      "updated_at":"2021-10-20T14:18:23.902+00:00"
   },
   {
      "id":"11c7c78b-3083-408a-9691-31ebe44e8378",
      "logicalname":"sustainability_baby_01_sitting_",
      "translations":{
         "nb_NO":"Baby 01 sitter",
         "nn_NO":"Baby 01 sit",
         "sv_SE":"Bebis 01 Sitter",
         "en_US":"Baby 01 sitting",
         "da_DK":"Baby 01 sidder"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "curious",
         "sleeping",
         "crying"
      ],
      "tags":[
         
      ],
      "width":103,
      "height":129,
      "position":28,
      "updated_at":"2021-10-20T14:18:24.273+00:00"
   },
   {
      "id":"41b860ec-5a30-4df7-ac75-ca15d92250ed",
      "logicalname":"sustainability_baby_01_lying_",
      "translations":{
         "nb_NO":"Baby 01 ligger",
         "nn_NO":"Baby 01 ligg",
         "sv_SE":"Bebis 01 Ligger",
         "en_US":"Baby 01 lying down",
         "da_DK":"Baby 01 ligger ned"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "curious",
         "sleeping",
         "crying"
      ],
      "tags":[
         
      ],
      "width":150,
      "height":84,
      "position":29,
      "updated_at":"2021-10-20T14:18:24.729+00:00"
   },
   {
      "id":"85c4daf9-dad3-4f00-a7c3-312ee50d5236",
      "logicalname":"sustainability_baby_01_crawling_",
      "translations":{
         "nb_NO":"Baby 01 krabber",
         "nn_NO":"Baby 01 krabbar",
         "sv_SE":"Bebis 01 kryper",
         "en_US":"Baby 01 crawling",
         "da_DK":"Baby 01 kravler"
      },
      "theme":"sustainable_development",
      "type":"people",
      "moods":[
         "normal",
         "happy",
         "curious",
         "sleeping",
         "crying"
      ],
      "tags":[
         
      ],
      "width":133,
      "height":101,
      "position":30,
      "updated_at":"2021-10-20T14:18:25.030+00:00"
   },
   {
      "id":"1b8b0781-cb42-4541-9344-35d5fbebc75b",
      "logicalname":"sustainability_props_bucket_",
      "translations":{
         "nb_NO":"Bøtte",
         "nn_NO":"Bøtte",
         "sv_SE":"Hink",
         "en_US":"Bucket",
         "da_DK":"Spand"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02",
         "03"
      ],
      "tags":[
         
      ],
      "width":70,
      "height":72,
      "position":0,
      "updated_at":"2021-10-20T14:18:25.485+00:00"
   },
   {
      "id":"cb7f41c1-e8ba-45c2-aae8-e5b791a817f0",
      "logicalname":"sustainability_props_bulldozer_",
      "translations":{
         "nb_NO":"Bulldoser",
         "nn_NO":"Bulldosar",
         "sv_SE":"Bulldozer",
         "en_US":"Bulldozer",
         "da_DK":"Bulldozer"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02",
         "03"
      ],
      "tags":[
         
      ],
      "width":404,
      "height":181,
      "position":1,
      "updated_at":"2021-10-20T14:18:25.778+00:00"
   },
   {
      "id":"d74e91ce-7f94-4bb1-939f-d729a65d393f",
      "logicalname":"sustainability_props_cow_",
      "translations":{
         "nb_NO":"Ku",
         "nn_NO":"Ku",
         "sv_SE":"Ko",
         "en_US":"Cow",
         "da_DK":"Ko"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02"
      ],
      "tags":[
         
      ],
      "width":158,
      "height":114,
      "position":2,
      "updated_at":"2021-10-20T14:18:26.091+00:00"
   },
   {
      "id":"6e4d2f42-2781-4cc8-891b-ebf9083c74b3",
      "logicalname":"sustainability_props_polarbear_",
      "translations":{
         "nb_NO":"Isbjørn",
         "nn_NO":"Isbjørn",
         "sv_SE":"Isbjörn",
         "en_US":"Polar bear",
         "da_DK":"Isbjørn"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02"
      ],
      "tags":[
         
      ],
      "width":185,
      "height":97,
      "position":3,
      "updated_at":"2021-10-20T14:18:26.400+00:00"
   },
   {
      "id":"2c8e7eb0-d9f7-407e-9bb2-c5a75c2f8a82",
      "logicalname":"sustainability_props_recycle_",
      "translations":{
         "nb_NO":"Resirkuleringssymbol",
         "nn_NO":"Resirkuleringssymbol",
         "sv_SE":"Återvinning symbol",
         "en_US":"Recycling symbol",
         "da_DK":"Genbrugs symbol"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02",
         "03",
         "04"
      ],
      "tags":[
         
      ],
      "width":86,
      "height":84,
      "position":4,
      "updated_at":"2021-10-20T14:18:26.805+00:00"
   },
   {
      "id":"16d0f302-b6ae-4dca-abd1-047db54991f6",
      "logicalname":"sustainability_props_solar-panel_",
      "translations":{
         "nb_NO":"Solpanel",
         "nn_NO":"Solpanel",
         "sv_SE":"Solpanel",
         "en_US":"Solar panel",
         "da_DK":"Solcelle"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02",
         "03"
      ],
      "tags":[
         
      ],
      "width":181,
      "height":135,
      "position":5,
      "updated_at":"2021-10-20T14:18:27.100+00:00"
   },
   {
      "id":"dee4e5c8-5c38-4ed4-973a-37f50ba52b55",
      "logicalname":"sustainability_props_whale_",
      "translations":{
         "nb_NO":"Hval",
         "nn_NO":"Kval",
         "sv_SE":"Val",
         "en_US":"Whale",
         "da_DK":"Hval"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02",
         "03"
      ],
      "tags":[
         
      ],
      "width":439,
      "height":199,
      "position":6,
      "updated_at":"2021-10-20T14:18:27.524+00:00"
   },
   {
      "id":"2d88cbe7-0263-42fd-ac9c-44e28fba5b02",
      "logicalname":"sustainability_props_plasticbottle_",
      "translations":{
         "nb_NO":"Plastflaske",
         "nn_NO":"Plastflaske",
         "sv_SE":"Plastflaska",
         "en_US":"Plastic bottle",
         "da_DK":"Plastikflaske"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02",
         "03"
      ],
      "tags":[
         
      ],
      "width":41,
      "height":147,
      "position":25,
      "updated_at":"2021-10-20T14:18:27.815+00:00"
   },
   {
      "id":"22f64607-61bf-41fa-bce6-a6d065cd90ff",
      "logicalname":"sustainability_props_salmon_",
      "translations":{
         "nb_NO":"Laks",
         "nn_NO":"Laks",
         "sv_SE":"Lax",
         "en_US":"Salmon",
         "da_DK":"Laks"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02"
      ],
      "tags":[
         
      ],
      "width":154,
      "height":56,
      "position":26,
      "updated_at":"2021-10-20T14:18:28.103+00:00"
   },
   {
      "id":"7a653854-6f4c-4ed2-9a89-03b20560ac38",
      "logicalname":"sustainability_props_bat_flying_",
      "translations":{
         "nb_NO":"Flaggermus 01",
         "nn_NO":"Flaggermus flygande",
         "sv_SE":"Fladdermus 01",
         "en_US":"Bat 01",
         "da_DK":"Flagermus 01"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02"
      ],
      "tags":[
         
      ],
      "width":702,
      "height":395,
      "position":30,
      "updated_at":"2021-10-20T14:18:28.395+00:00"
   },
   {
      "id":"7d4c7159-d9b1-4f9f-987c-159717b0f0be",
      "logicalname":"sustainability_props_bat_sleeping_",
      "translations":{
         "nb_NO":"Flaggermus 02",
         "nn_NO":"Flaggermus sovande",
         "sv_SE":"Fladdermus 02",
         "en_US":"Bat 02",
         "da_DK":"Flagermus 02"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         "01",
         "02"
      ],
      "tags":[
         
      ],
      "width":227,
      "height":446,
      "position":31,
      "updated_at":"2021-10-20T14:18:28.692+00:00"
   },
   {
      "id":"9f7af6a2-9564-4ad2-b71d-9348374a7fa8",
      "logicalname":"sustainability_props_virus_",
      "translations":{
         "nb_NO":"Virus",
         "nn_NO":"Virus",
         "sv_SE":"Virus",
         "en_US":"Virus",
         "da_DK":"Virus"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":468,
      "height":472,
      "position":33,
      "updated_at":"2021-10-20T14:18:29.088+00:00"
   },
   {
      "id":"6fb03e5f-84a4-4a2f-ac6a-580fa9ee4a83",
      "logicalname":"sustainability_props_facemask_",
      "translations":{
         "nb_NO":"Munnbind",
         "nn_NO":"Ansiktsmaske",
         "sv_SE":"Ansiktsmask",
         "en_US":"Face mask",
         "da_DK":"Ansigtsmaske"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":109,
      "height":54,
      "position":32,
      "updated_at":"2021-10-20T14:18:29.430+00:00"
   },
   {
      "id":"c498da09-5af5-4ad0-a494-83fff4b90c50",
      "logicalname":"sustainability_props_artificcial-meat_",
      "translations":{
         "nb_NO":"Kunstig kjøtt",
         "nn_NO":"Kunstig kjøt",
         "sv_SE":"Artificiellt kött",
         "en_US":"Artificial meat",
         "da_DK":"Kunstigt kød"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":61,
      "height":27,
      "position":7,
      "updated_at":"2021-10-20T14:18:29.721+00:00"
   },
   {
      "id":"64194d9e-5e68-4b0d-9ec8-694824147e69",
      "logicalname":"sustainability_props_algae_food_",
      "translations":{
         "nb_NO":"Alger",
         "nn_NO":"Algar",
         "sv_SE":"Alger",
         "en_US":"Algae",
         "da_DK":"Alger"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":171,
      "height":88,
      "position":27,
      "updated_at":"2021-10-20T14:18:30.013+00:00"
   },
   {
      "id":"5efe1b5d-1541-43ab-9438-747089d32850",
      "logicalname":"sustainability_props_exhaust_",
      "translations":{
         "nb_NO":"Eksos",
         "nn_NO":"Eksos",
         "sv_SE":"Avgasrör",
         "en_US":"Exhaust",
         "da_DK":"Udstødning"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":585,
      "height":404,
      "position":28,
      "updated_at":"2021-10-20T14:18:30.319+00:00"
   },
   {
      "id":"ddddc5fd-10c4-4984-8cee-ae1c0ff10195",
      "logicalname":"sustainability_props_insect_food_",
      "translations":{
         "nb_NO":"Insekter",
         "nn_NO":"Insekt",
         "sv_SE":"Insekt",
         "en_US":"Insect",
         "da_DK":"Insekt"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":233,
      "height":101,
      "position":29,
      "updated_at":"2021-10-20T14:18:30.751+00:00"
   },
   {
      "id":"3fdc804d-31e9-4b7f-bfc5-487bb533ee54",
      "logicalname":"sustainability_props_car_01_",
      "translations":{
         "nb_NO":"Bensinbil 01",
         "nn_NO":"Bensinbil 01",
         "sv_SE":"Bensinbil 01",
         "en_US":"Fossil fuel car 01",
         "da_DK":"Benzinbil 01"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":367,
      "height":111,
      "position":8,
      "updated_at":"2021-10-20T14:18:31.083+00:00"
   },
   {
      "id":"5ce2ffe2-95d4-4759-84aa-a8ce193d9aed",
      "logicalname":"sustainability_props_car_02_",
      "translations":{
         "nb_NO":"Bensinbil 02",
         "nn_NO":"Bensinbil 02",
         "sv_SE":"Bensinbil 02",
         "en_US":"Fossil fuel car 02",
         "da_DK":"Benzinbil 02"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":287,
      "height":125,
      "position":9,
      "updated_at":"2021-10-20T14:18:31.389+00:00"
   },
   {
      "id":"62b18867-a13b-459f-96ca-cb7ca0bed4af",
      "logicalname":"sustainability_props_car_03_",
      "translations":{
         "nb_NO":"Elbil 01",
         "nn_NO":"Elbil 01",
         "sv_SE":"El-bil 01",
         "en_US":"Electric car 01",
         "da_DK":"Elbil 01"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":245,
      "height":116,
      "position":10,
      "updated_at":"2021-10-20T14:18:31.673+00:00"
   },
   {
      "id":"6c5d3f8b-e797-4bfe-ae90-d88f2c417135",
      "logicalname":"sustainability_props_car_04_",
      "translations":{
         "nb_NO":"Elbil 02",
         "nn_NO":"Elbil 02",
         "sv_SE":"El-bil 02",
         "en_US":"Electric car 02",
         "da_DK":"Elbil 02"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":239,
      "height":105,
      "position":11,
      "updated_at":"2021-10-20T14:18:32.064+00:00"
   },
   {
      "id":"491001ff-7d6b-4616-b90d-ec67a55c730e",
      "logicalname":"sustainability_props_fishing-boat_",
      "translations":{
         "nb_NO":"Fiskebåt",
         "nn_NO":"Fiskebåt",
         "sv_SE":"Fiskefartyg",
         "en_US":"Fishing vessel",
         "da_DK":"Fiskebåd"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":392,
      "height":202,
      "position":13,
      "updated_at":"2021-10-20T14:18:32.763+00:00"
   },
   {
      "id":"d9cf36a1-cfc7-43c6-8fe5-aae2b40f44b6",
      "logicalname":"sustainability_props_gasoline_",
      "translations":{
         "nb_NO":"Bensinfat",
         "nn_NO":"Bensinfat",
         "sv_SE":"Oljefat",
         "en_US":"Gasoline drum",
         "da_DK":"Benzin tønde"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":60,
      "height":99,
      "position":14,
      "updated_at":"2021-10-20T14:18:33.103+00:00"
   },
   {
      "id":"11520d79-b6ef-4300-b9ee-4cb7b574c753",
      "logicalname":"sustainability_props_happy-earth_",
      "translations":{
         "nb_NO":"Jordkloden (frisk)",
         "nn_NO":"Jordkloden (frisk)",
         "sv_SE":"Jorden (glad)",
         "en_US":"Earth (healthy)",
         "da_DK":"Jorden (sund)"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":296,
      "height":293,
      "position":15,
      "updated_at":"2021-10-20T14:18:33.430+00:00"
   },
   {
      "id":"4382b4b5-de82-4dfe-851a-621ffe7b70be",
      "logicalname":"sustainability_props_meat_",
      "translations":{
         "nb_NO":"Kjøtt",
         "nn_NO":"Kjøt",
         "sv_SE":"Kött",
         "en_US":"Meat",
         "da_DK":"Kød"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":67,
      "height":37,
      "position":16,
      "updated_at":"2021-10-20T14:18:33.805+00:00"
   },
   {
      "id":"62433fb2-8c51-45ed-9850-5236babbebf1",
      "logicalname":"sustainability_props_oil_",
      "translations":{
         "nb_NO":"Oljefat",
         "nn_NO":"Oljefat",
         "sv_SE":"Oljetrumma",
         "en_US":"Oil drum",
         "da_DK":"Olie tønde"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":58,
      "height":99,
      "position":17,
      "updated_at":"2021-10-20T14:18:34.145+00:00"
   },
   {
      "id":"301c76a4-019a-4081-9c84-7dc6aea54b30",
      "logicalname":"sustainability_props_plane_",
      "translations":{
         "nb_NO":"Fly",
         "nn_NO":"Fly",
         "sv_SE":"Flygplan",
         "en_US":"Airplane",
         "da_DK":"Flyvemaskine"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":457,
      "height":142,
      "position":18,
      "updated_at":"2021-10-20T14:18:34.475+00:00"
   },
   {
      "id":"f8fa86f6-2b4f-4f46-9d85-3b2ff7d24b09",
      "logicalname":"sustainability_props_poison_",
      "translations":{
         "nb_NO":"Tønne med giftig innhold",
         "nn_NO":"Tønne med giftig innhald",
         "sv_SE":"Gifttrumma",
         "en_US":"Poison drum",
         "da_DK":"Gift tønde"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":59,
      "height":99,
      "position":19,
      "updated_at":"2021-10-20T14:18:34.813+00:00"
   },
   {
      "id":"8455bb96-6360-48a8-8608-b9d456fa96e5",
      "logicalname":"sustainability_props_sad-earth_",
      "translations":{
         "nb_NO":"Jordkloden (syk)",
         "nn_NO":"Jordkloden (sjuk)",
         "sv_SE":"Jorden (sjuk)",
         "en_US":"Earth (sick)",
         "da_DK":"Jorden (syg)"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":304,
      "height":308,
      "position":20,
      "updated_at":"2021-10-20T14:18:35.119+00:00"
   },
   {
      "id":"084cfd57-2ef4-4378-987b-06c386b36175",
      "logicalname":"sustainability_props_skeleton_",
      "translations":{
         "nb_NO":"Dyreskjelett",
         "nn_NO":"Dyreskjelett",
         "sv_SE":"Djurskelett",
         "en_US":"Animal skeleton",
         "da_DK":"Dyre skelet"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":220,
      "height":97,
      "position":21,
      "updated_at":"2021-10-20T14:18:35.414+00:00"
   },
   {
      "id":"3437861e-61f8-4cb5-84b5-c3746758790a",
      "logicalname":"sustainability_props_train_",
      "translations":{
         "nb_NO":"Tog",
         "nn_NO":"Tog",
         "sv_SE":"Tåg",
         "en_US":"Train",
         "da_DK":"Tog"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":1423,
      "height":101,
      "position":22,
      "updated_at":"2021-10-20T14:18:35.773+00:00"
   },
   {
      "id":"2bb5f565-692a-4aa9-969c-5cbc1eb1ab83",
      "logicalname":"sustainability_props_trunks_",
      "translations":{
         "nb_NO":"Trestammer",
         "nn_NO":"Trestammar",
         "sv_SE":"Trädstammar",
         "en_US":"Tree trunks",
         "da_DK":"Træstammer"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":396,
      "height":151,
      "position":23,
      "updated_at":"2021-10-20T14:18:36.097+00:00"
   },
   {
      "id":"118d69fc-6f32-4297-b60a-ce7fdfcd3aa4",
      "logicalname":"sustainability_props_vindmill_",
      "translations":{
         "nb_NO":"Vindmølle",
         "nn_NO":"Vindmølle",
         "sv_SE":"Vindkraftverk",
         "en_US":"Windmill",
         "da_DK":"Vindmølle"
      },
      "theme":"sustainable_development",
      "type":"props",
      "moods":[
         
      ],
      "tags":[
         
      ],
      "width":156,
      "height":291,
      "position":24,
      "updated_at":"2021-10-20T14:18:36.398+00:00"
   }
]`
};


/** WEBPACK FOOTER **
 ** ./docs/newTheme.js
 **/